<app-page-loader [visible]="isLoading()"/>

<router-outlet/>
